// src/routes/(app)/+page.ts
import { getMembershipPlans } from '$lib/services/memberships';
import { getPage } from '$lib/services/page';
import { getPlaylist } from '$lib/services/playlists';
import { getTrustedPartners } from '$lib/services/partners';
import { getBenefits } from '$lib/services/benefits';
import { getVideoSectors } from '$lib/services/videos';

export const load = async ({ parent, depends }) => {
	depends('app:user');
	const { balancedSupabase, user } = await parent();

	const [
		page,
		memberships,
		partners,
		knowledgebasePage,
		benefits,
		sectors,
		headersResponse,
		homepagePlaylistsResponse
	] = await Promise.all([
		getPage(balancedSupabase, '2fb793af-6eb3-430b-9fad-4830fc0174af'),
		getMembershipPlans(balancedSupabase),
		getTrustedPartners(balancedSupabase),
		getPage(balancedSupabase, '7c752c3a-d45a-40b8-9633-969ee9ec82e7'),
		getBenefits(balancedSupabase),
		getVideoSectors(balancedSupabase),
		balancedSupabase
			.from('homepage_headers')
			.select(
				`
        id,
        title,
        subtitle,
        btn_text,
        btn_link,
        image_url,
        public_image_url,
        order,
        video_id,
        video:videos(
          id,
          name,
          description,
          public_image_url,
          vimeo_id
        )
      `
			)
			.eq('active', true)
			.order('order'),
		balancedSupabase
			.from('homepage_playlists')
			.select(
				`
        id,
        order,
        playlist_id,
        playlist:playlists!inner(
          id,
          name,
          description,
          public_image_url
        )
      `
			)
			.order('order')
	]);

	// Get the playlist details with videos for each homepage playlist
	const playlistPromises = (homepagePlaylistsResponse.data || []).map((item) =>
		getPlaylist(balancedSupabase, item.playlist_id, user)
	);

	const playlists = await Promise.all(playlistPromises);

	return {
		page,
		headers: headersResponse.data || [],
		memberships,
		homepagePlaylists: playlists,
		partners,
		knowledgebasePage,
		benefits,
		sectors
	};
};
